import { t } from 'i18next';
import { useDispatch } from 'react-redux';
import { MainButton } from '../../../components/Buttons/MainButton';
import { setAccountSettingsModals } from '../../../redux/accountSettingsPage/accountSettingsSlice';
import {
  accountSettingsCardFieldStyles,
  fieldRowStyles,
  settingTitleStyles,
} from './styles';

const AccountSettingsNotificationsField = () => {
  const dispatch = useDispatch();

  const openNotificationPreferencesModal = () => {
    dispatch(
      setAccountSettingsModals({ isNotificationPreferencesModalOpen: true }),
    );
  };

  return (
    <div style={accountSettingsCardFieldStyles}>
      <div style={fieldRowStyles.row}>
        <div style={{ ...fieldRowStyles.infoContainer, ...settingTitleStyles }}>
          {t('accountSettings.notifications')}
        </div>
        <MainButton
          onPress={openNotificationPreferencesModal}
          variant="outlined"
          size="small"
          typeStyle="secondary"
          text={t('common.change')}
        />
      </div>
    </div>
  );
};

export default AccountSettingsNotificationsField;
